const error400 = (data) => {
  switch (data.code) {
    case "4000004":
      return {
        code: "4000004",
        message: data.description.tr || null,
        error: data,
      };
    case "4220002":
      return {
        code: "4220002",
        message: "Giriş Yapabilmek için lütfen aktivasyon işlemini tamamlayınız",
        error: data,
      };
    case "4000011":
      return {
        code: "4000011",
        message: "Bu eposta kayıtlı değildir",
        error: data,
      };
    default:
      return {
        code: data.code,
        message: data?.description?.tr || "Yanlış e-posta adresi ya da şifre girdiniz.",
        error: data,
      };
  }
};

export const getMessage = (response) => {
  if (response && typeof response === "object" && Object.keys(response).length > 0) {
    const { code } = response;
    const errorTypes = `${code?.toString()[0]}xx`;
    switch (errorTypes) {
      case "4xx": {
        return error400(response);
      }
      default:
        return {
          code: null,
          message: "Bir hata oluştu. Lütfen tekrar deneyiniz.",
          error: response || "",
        };
    }
  }
  return {
    code: null,
    message: "Bir hata oluştu. Lütfen tekrar deneyiniz.",
    error: "",
  };
};

export default getMessage;
